import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useId, useState } from "react";
import { LinkListBlock, PlainContentModuleContainer, TabBodyContentBlock, TabListContentBlock } from "@silvertours/front-entities";
import { Destination } from "../destination";
export var Tabs = function(param) {
    var badge = param.badge, heading = param.heading, modules = param.modules, rules = param.rules, translations = param.translations;
    var tabGroup = "tabGroup-".concat(useId());
    var ref = useState(modules.length && modules[0].name || ""), currentTab = ref[0], setCurrentTab = ref[1];
    if (modules.length === 0) {
        return null;
    }
    var textStyle = (rules || {}).textStyle;
    return /*#__PURE__*/ _jsxs(PlainContentModuleContainer, {
        children: [
            /*#__PURE__*/ _jsx(TabListContentBlock, {
                behavior: {
                    onTabSelected: setCurrentTab
                },
                content: {
                    badge: badge,
                    heading: heading,
                    modules: modules
                },
                rules: {
                    textStyle: textStyle
                }
            }),
            modules.map(function(subModule) {
                /*#__PURE__*/ return _jsx(TabBodyContentBlock, {
                    content: {
                        currentTab: currentTab,
                        subModule: subModule,
                        tabGroup: tabGroup
                    },
                    rules: {
                        textStyle: textStyle
                    },
                    children: function(module) {
                        switch(module.moduleType){
                            case "linkList":
                                return /*#__PURE__*/ _jsx(LinkListBlock, {
                                    content: module
                                });
                            case "destination":
                            default:
                                return /*#__PURE__*/ _jsx(Destination, _object_spread_props(_object_spread({}, module), {
                                    rules: rules,
                                    translations: translations === null || translations === void 0 ? void 0 : translations.destination
                                }));
                        }
                    }
                }, subModule.name);
            })
        ]
    });
};
